<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-doubleup`]" width="1em" height="1em" v-bind="$attrs"><path d="M7.17622 8.77081C7.6312 8.31604 8.36976 8.31592 8.82466 8.77081L11.9711 11.9163L12.0561 12.0208C12.2264 12.2788 12.1982 12.6305 11.9711 12.8577C11.744 13.0849 11.3923 13.1129 11.1342 12.9427L11.0297 12.8577L8.00044 9.82843L4.97114 12.8577C4.71153 13.1173 4.28945 13.1172 4.02973 12.8577C3.77004 12.598 3.77004 12.176 4.02973 11.9163L7.17622 8.77081ZM7.17622 3.49737C7.6312 3.04261 8.36976 3.04248 8.82466 3.49737L11.9711 6.64288L12.0561 6.74737C12.2264 7.00541 12.1982 7.35708 11.9711 7.58429C11.744 7.81146 11.3923 7.83951 11.1342 7.66925L11.0297 7.58429L8.00044 4.55499L4.97114 7.58429C4.71153 7.8439 4.28945 7.84374 4.02973 7.58429C3.77004 7.32459 3.77004 6.90258 4.02973 6.64288L7.17622 3.49737Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineDoubleup',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
